// extracted by mini-css-extract-plugin
module.exports = {"articleSection":"article_articleSection__cXuEw","noLinkStyle":"article_noLinkStyle__P_cQ6"};